import script from "./TargetData.vue?vue&type=script&lang=ts&setup=true"
export * from "./TargetData.vue?vue&type=script&lang=ts&setup=true"

import "./TargetData.vue?vue&type=style&index=0&id=5d922ec1&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d922ec1"]])

export default __exports__